import { component } from 'picoapp'

export default component((node,ctx) => {
    /*******************************************************************************************************************************************/
    /* Data + Elements
    /*******************************************************************************************************************************************/
    const { currentBrand } = node.dataset
    const gender = localStorage.getItem('spreeglee_gender') || 'unisex'
    const matchingBrand = window.theme.brands.find(brand => brand.vendor_name.toLowerCase() === currentBrand.toLowerCase())


    /*******************************************************************************************************************************************/
    /* Insert Brand Logo
    /*******************************************************************************************************************************************/
    if (matchingBrand) insertBrandLogo(matchingBrand)

    function insertBrandLogo(brand) {
        node.innerHTML =    `
                            <a href="${brand[`link_url_${gender}`]}">
                                <img src="${brand.logo_dark}" alt="${brand.vendor_name}">
                            </a>
                            `
    }
})